import { useEffect } from 'react';
import { isEmpty } from 'lodash';
import {
    DispatchFetchInlineBoardLinkDetails,
    InlineBoardLinkAttributes,
    InlineBoardLinkStatus,
} from './inlineBoardLinkConstants';
import { Attrs } from '@tiptap/pm/model';

type UseSyncInlineBoardLinkDetailsProps = {
    dispatchFetchInlineBoardLinkDetails: DispatchFetchInlineBoardLinkDetails;
    attrs: Attrs;
    updateAttributes: (attrs: Record<string, any>) => void;
};

const useSyncInlineBoardLinkDetails = ({
    dispatchFetchInlineBoardLinkDetails,
    attrs,
    updateAttributes,
}: UseSyncInlineBoardLinkDetailsProps) => {
    useEffect(() => {
        dispatchFetchInlineBoardLinkDetails(attrs.boardId, attrs.permissionId)
            .catch((err) => {
                console.error('Failed to fetch inline board link details:', err);
                return null;
            })
            .then((details) => {
                const attributeDetails: Partial<InlineBoardLinkAttributes> = {
                    ...details,
                    status: InlineBoardLinkStatus.resolved,
                };
                const updates: Partial<InlineBoardLinkAttributes> = {};

                for (const keyStr in attributeDetails) {
                    const key = keyStr as keyof InlineBoardLinkAttributes;

                    if (!!attributeDetails[key] && attributeDetails[key] !== attrs[key]) {
                        updates[key] = attributeDetails[key];
                    }
                }

                if (isEmpty(updates)) return;

                // Update the node view to reflect the resolved state
                updateAttributes(updates);
            });
    }, []);
};

export default useSyncInlineBoardLinkDetails;
